// import Vue from 'vue';
import {DateTime} from 'luxon';
export default function (value) {
  if (!value) return 'N/A';
  return DateTime.fromISO(value).setLocale('fr').toRelative({style: 'short'});
}
